<template lang="pug">
#bloco-inserir-territorio-certificacao-planilha
    h1 Inserir dados do território para análise de certificação
    el-card
        .box-card-inserir-territorio-planilha
            .box-card-inserir-territorio-planilha__conteudo
                .box-card-inserir-territorio-planilha__conteudo__bloco
                    div
                        span Para agilizar seu processo, você pode adicionar os imóveis de uma vez só atravez de uma planilha.
                        span Campos obrigatórios:
                        b  CAR, Pessoa e CPF/CNPJ

                el-upload.upload-demo(
                    drag='' action='#',
                    :auto-upload='false',
                    :show-file-list='false',
                    :on-change='enviarPlanilha',
                    :limit='1',
                    ref='uploadPlanilhaTerritorio'
                )
                    i.el-icon-upload
                    .el-upload__text
                        | Arraste o arquivo aqui ou <em>clique para realizar o upload.</em>
                .box-card-inserir-territorio-planilha__conteudo__bloco
                    .box-card-inserir-territorio-planilha__conteudo__bloco__buttons
                        span.btn-download(@click='downloadPlanilhaExemplo()')
                            i.mdi.mdi-download
                            span Baixar modelo de planilha
                div(v-if='progressActive')
                    el-progress.el-progress-certification(
                        :text-inside="true"
                        :color="customColor"
                        :stroke-width="18"
                        :percentage="percentage"
                        :text-color="progressTextColor"
                    )
</template>

<script>
import CertificacaoService from '@/services/CertificacaoService';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoInserirPlanilhaCertificacao',
    components: {},
    props: {
        tiposCertificaoesSelecionadas: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            fileList: [],
            customColor: '#043c5a',
            percentage: 0,
            progressActive: false,
            progressTextColor: 'white'
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.conectarCanalNotificacaoProcessamento();
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        async enviarPlanilha(planilha) {
            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: 'Esse arquivo ultrapassa 15MB.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error({
                    message:
                        'Apenas arquivos com a extensão XLSX são suportados.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            try {
                const { data } = await CertificacaoService.cadastrarViaPlanilha(planilha, this.tiposCertificaoesSelecionadas);
                this.progressActive = true;
                await CertificacaoService.processarPlanilha(data);
                this.$notify.success({
                    message:
                        'Processando seu arquivo...'
                });
            } catch (error) {
                if (error?.response?.data?.status === 400) {
                    this.$notify.error({
                        message: error?.response?.data?.message
                    });
                } else {
                    this.$notify.error({
                        message: 'Erro ao realizar upload do arquivo.'
                    });
                }
            } finally {
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                this.$emit('atualizar-tabela-certificacao-lote', planilha);
            }
        },
        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: 'Não foi possível se conectar na api!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/certificacao-territorio/cadastro`,
                    response => {
                        this.percentage = JSON.parse(response);
                        if (this.percentage === 100) {
                            this.$emit('atualizar-tabela-certificacao-lote', response);
                            this.$notify.success({
                                message:
                                    'Arquivo processado com sucesso.'
                            });
                            setTimeout(() => {
                                this.progressActive = false;
                            }, 1000);
                        } else {
                            this.progressActive = true;
                        }
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível se inscrever no websocket!'
                });
                disconnect();
            }
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            link.setAttribute(
                'download',
                'planilha-exemplo-certificacao-territorio'
            );
            link.href =
                'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-certificacao-territorio.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        fazerDownload(id) {
            CertificacaoService.downloadPlanilhaComErro(id)
                .then(() => {
                    this.$notify.success({
                        message: 'Download realizado com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar download!'
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-inserir-territorio-certificacao-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .lista {
        display: flex;
        flex-direction: row;
    }

    .el-card.is-always-shadow {
        min-height: 370px;
    }

    el-card {
        margin-top: 10px;
    }

    .box-card-inserir-territorio-planilha {
        height: 333px;
    }
    .box-card-inserir-territorio-planilha__conteudo {
        display: flex;
        flex-direction: column;
        min-height: 297px;
        justify-content: space-between;
        font-size: 16px;
        gap: 15px;

        .box-card-inserir-territorio-planilha__conteudo__bloco {
            display: flex;
            .box-card-inserir-territorio-planilha__conteudo__bloco__buttons {
                display: flex;
                gap: 15px;
                width: 100%;
                justify-content: flex-end;
                align-items: center;
                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }

            .box-card-inserir-territorio-planilha__conteudo__bloco__lista {
                ul {
                    margin-bottom: 15px;
                }

                li.required-field::after {
                    content: ' *';
                    color: #f56c6c;
                }
            }
        }
    }

    .bloco-inserir-territorio-planilha-lote-importada {
        display: flex;
        justify-content: space-between;

        .bloco-inserir-territorio-planilha-lote-importada_bloco {
            font-size: 12px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            max-width: 34%;
        }

        .bloco-inserir-territorio-planilha-lote__label {
            font-weight: bold;
            color: var(--primary);
        }

        .bloco-inserir-territorio-planilha-lote-importada_nome {
            display: inline-block;
            width: 120px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }

        .bloco-inserir-territorio-lote__status {
            font-size: 11px;
        }
        .bloco-inserir-territorio-planilha-lote__button {
            font-size: 11px;
        }

        .bloco-inserir-territorio-planilha-lote-importada_data {
            display: inline-block;
            width: 100px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }
    }
}
</style>
